import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import styles from './style.module.less';

const name = <FormattedMessage {...messages.intlServiceIdColumnHeader} />;
const checkmarkIcon = <FontAwesomeIcon className={styles['active-checkmark']} icon={faCheck} />;

export default {
  getMessageDescriptor: () => messages.intlServiceIdColumnHeader,
  name,
  render: (data) => data.intlServiceId && checkmarkIcon,
};
